var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 192,
    viewBox: "0 0 168 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 96C96.7304 96 108.939 90.9429 117.941 81.9411C126.943 72.9394 132 60.7304 132 48C132 35.2696 126.943 23.0606 117.941 14.0589C108.939 5.05713 96.7304 0 84 0C71.2696 0 59.0606 5.05713 50.0589 14.0589C41.0571 23.0606 36 35.2696 36 48C36 60.7304 41.0571 72.9394 50.0589 81.9411C59.0606 90.9429 71.2696 96 84 96ZM66.8625 114C29.925 114 0 143.925 0 180.862C0 187.012 4.9875 192 11.1375 192H156.862C163.012 192 168 187.012 168 180.862C168 143.925 138.075 114 101.138 114H66.8625Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserAvatar);
export default __webpack_public_path__ + "static/media/default-user-avatar.702e614d36a912ceee6c207cb7674e53.svg";
export { ForwardRef as ReactComponent };